import {
    useEffect,
    useState,
} from 'react'
import {
    useDispatch,
    useSelector,
} from 'react-redux'
import { useSearchParams } from 'react-router-dom'

import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    Button,
    Text,
    Box,
    Input,
} from '@chakra-ui/react'

import { forgottenPasswordReset } from '../../features/auth/authSlice'

import { useFormik } from 'formik'
import * as Yup from 'yup'


export default function PasswordResetFormView() {

    const { passwordResetRequest } = useSelector((state) => state.auth)

    const [searchParams] = useSearchParams()
    const dispatch = useDispatch()

    const [isOpen, setIsOpen] = useState(true) // useDisclosure didn't work

    const verificationToken = searchParams.get("verificationToken")
    const email = searchParams.get("forEmail")

    useEffect(() => {
        if (verificationToken && email)
            window.history.replaceState(null, "? - TrainLookout", "/")
    }, [verificationToken, email])

    const formik = useFormik({
        initialValues: {
            email: email,
            password: "",
            confirmPassword: "",
        },
        validationSchema: Yup.object({
            password: Yup.string()
                .min(8, "Password must have a minimum of 8 characters")
                .max(40, "Password cannot be longer than 40 characters")
                .required("Password is required"),
            confirmPassword: Yup.string()
                .min(8, "Password must have a minimum of 8 characters")
                .max(40, "Password cannot be longer than 40 characters")
                .oneOf([Yup.ref('password'), null], 'Passwords must match')
                .required("Password confirmation is required"),
        }),
        onSubmit: (values) => {
            const formData = {
                email: values.email,
                verificationToken: verificationToken,
                password: values.password,
                confirmPassword: values.confirmPassword,
            }
            dispatch(forgottenPasswordReset({ formData }))
        }
    })

    if (verificationToken && email) {
        return (
            <>
                <Modal isOpen={isOpen}>
                    <ModalOverlay />
                    <ModalContent>
                        <ModalHeader>Reset password</ModalHeader>
                        <ModalBody>
                            {passwordResetRequest.isSuccess && (<Text>Password changed successfully. Please log in with your new credentials.</Text>)}
                            {passwordResetRequest.isError && (<Text>Error changing password: {passwordResetRequest.message}</Text>)}

                            {(formik.errors.password && formik.touched.password) && (<Box>{formik.errors.password}</Box>)}
                            {(formik.errors.confirmPassword && formik.touched.confirmPassword) && (<Box>{formik.errors.confirmPassword}</Box>)}
                            <Input
                                name='email'
                                id='email'
                                type='email'
                                placeholder='Email'
                                value={formik.values.email}
                                isDisabled
                            />
                            {(formik.errors.email && formik.touched.email) && (<Box>{formik.errors.email}</Box>)}
                            <Input
                              type="password"
                              placeholder="Password"
                              value={formik.values.password}
                              id="password" name="password"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              isDisabled={(passwordResetRequest.isSuccess || passwordResetRequest.isError || passwordResetRequest.isLoading)}
                            />
                            {(formik.errors.email && formik.touched.email) && (<Box>{formik.errors.email}</Box>)}
                            <Input
                              type="password"
                              placeholder="Confirm password"
                              value={formik.values.confirmPassword}
                              id="confirmPassword" name="confirmPassword"
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              isDisabled={(passwordResetRequest.isSuccess || passwordResetRequest.isError || passwordResetRequest.isLoading)}
                            />
                        </ModalBody>

                        <ModalFooter>
                            <Button
                                colorScheme='blue'
                                onClick={() => formik.handleSubmit()}
                                isDisabled={(passwordResetRequest.isSuccess || passwordResetRequest.isError)}
                                isLoading={passwordResetRequest.isLoading}
                                
                            >
                                Change password
                            </Button>
                            <Button 
                                onClick={() => setIsOpen(false)}
                            >
                                Close
                            </Button>
                        </ModalFooter>
                    </ModalContent>
                </Modal>
            </>
        )
    }
}
